import Modal from '@components/presentational/CustomModal/Modal';
import ModalBody from '@components/presentational/CustomModal/ModalBody';
import { Button, Flex, Radio, RadioGroup, Text } from '@chakra-ui/react';
import ModalFooter from '@components/presentational/CustomModal/ModalFooter';
import { useState } from 'react';

export default function MobilePublicationTypeFilterModal({
  filters,
  orders,
  currentFilter,
  currentOrder,
  onClose,
  onSubmit,
}: {
  filters: { label: string; value: string }[];
  orders: { label: string; value: string }[];
  currentFilter: string;
  currentOrder: string;
  onClose: Function;
  onSubmit: Function;
}) {
  const [filter, setFilter] = useState(currentFilter);
  const [order, setOrder] = useState(currentOrder);
  return (
    <Modal isOpen onClose={onClose} accentColor="tournesol" size="full">
      <ModalBody>
        <Flex direction="column" gap="1rem">
          <Flex direction="column" gap="0.5rem">
            <Text
              color="brand.100"
              fontWeight="600"
              fontSize={['1rem', '', '1.25rem']}
            >
              Trier par
            </Text>
            <RadioGroup
              value={order}
              onChange={value => {
                setOrder(value);
              }}
            >
              <Flex direction="column" gap="0.5rem">
                {orders.map(order => {
                  return <Radio value={order.value}>{order.label}</Radio>;
                })}
              </Flex>
            </RadioGroup>
          </Flex>
          <Flex direction="column" gap="0.5rem">
            <Text
              color="brand.100"
              fontWeight="600"
              fontSize={['1rem', '', '1.25rem']}
            >
              Filtrer
            </Text>
            <RadioGroup
              value={filter}
              onChange={value => {
                setFilter(value);
              }}
            >
              <Flex direction="column" gap="0.5rem">
                {filters.map(filter => {
                  return <Radio value={filter.value}>{filter.label}</Radio>;
                })}
              </Flex>
            </RadioGroup>
          </Flex>
        </Flex>
      </ModalBody>
      <ModalFooter>
        <Button
          size="sm"
          variant="sunflower"
          width="100%"
          onClick={() => {
            onSubmit({ filter, order });
          }}
        >
          Valider
        </Button>
      </ModalFooter>
    </Modal>
  );
}
